/**
 * Route for `expo-sdk-plugin-wrapper`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ExpoSdkPluginWrapperPage } from "../features/expo-sdk-plugin-wrapper/ExpoSdkPluginWrapperPage";

export const expoSdkPluginWrapperRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/expo-sdk-plugin-wrapper",
	component: ExpoSdkPluginWrapperPage,
});

export default expoSdkPluginWrapperRoute;
